// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>11</span>&nbsp;&nbsp;The Lord of hosts is with us;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the God of Jacob is our stronghold.<br> </p> </div></div>";
// Exports
module.exports = code;